<template>
  <Container type="card-full">
    <div v-loading="loading">
      <div slot="header">
        <div class="view-container">
          <div class="view-box">
            <rowTem :rowList="[
              [
                { lable: '项目编号', value: project.projectcode },
                { lable: '平台编号', value: project.projectno },
                { lable: '采购人', value: project.pcomfullname }
              ],
              [
                { lable: '项目名称', value: project.projectname }
              ]
            ]" />
          </div>
        </div>
      </div>
      <div class="main">
        <div class="view-container">
          <div class="view-box">
            <ProjectStatus :projectid="$route.params.projectid" :projectstatus="project.projectstatus" />
            <changeAppend :appendList="project.appendList_zb" :id="project.projectid" />
            <BiddingTimeStatus :Project="project" />
            <PurchaseReportStatus :projectjjbgstatus="project.projectjjbgstatus" :projectid="$route.params.projectid" />
            <RegistrationList :projectid="$route.params.projectid" />
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import request from "@/utils/request";
import _ from "lodash";
import clipButton from "../../components/clipButton";


import ProjectStatus from "./component/ProjectStatus";
import BiddingTimeStatus from "./component/BiddingTimeStatus";
import PurchaseReportStatus from "./component/PurchaseReportStatus";
import RegistrationList from "./component/RegistrationList";
import changeAppend from "./component/changeAppend";

import rowTem from './component/rowTem'

export default {
  name: "changeStatusFrom",
  data() {
    return {
      loading: false,
      project: {}
    };
  },
  components: {
    clipButton,
    ProjectStatus,
    BiddingTimeStatus,
    PurchaseReportStatus,
    RegistrationList,
    changeAppend,
    rowTem
  },
  async activated() {
    await this.getModel();
  },
  methods: {
    async getModel() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/project/findProjectById",
        params: { projectid: this.$route.params.projectid },
      });
      this.project = res;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.split-box {
  margin: 11px 0 15px;

  .split-line {
    margin: 5px;
  }

  .split-name {
    font-weight: bold;
  }
}
</style>
